import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./css/Loyalty.css";

class Loyalty extends Component {

    state = {
        currentStreak: 0,
        longestStreak: 0,
        lastActiveDate: "",
        isEligible: false,
        isConfirmModal: false,
        isSuccessModal: false,
        loading: false,
        claimLoading: false,
    };

    TOTAL_DAYS = 30;
    REWARD_TEXT = "۲۰۰,۰۰۰ تومان هدیه نقدی";
    REWARD_BONUS_TEXT = "۱ فرصت چرخاندن گردونه شانس";

    componentDidMount() {
        this.getLoyaltyStatus();
    }

    // ============ API Calls ============
    getLoyaltyStatus = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        this.setState({ loading: true });

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        };
        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/loyalty-status`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                this.setState({ loading: false });

                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState({
                            currentStreak: myObject.data.currentStreak || 0,
                            longestStreak: myObject.data.longestStreak || 0,
                            lastActiveDate: myObject.data.lastActiveDate || "",
                            isEligible: myObject.data.isEligible || false,
                        });
                    }
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                console.log("getLoyaltyStatus error", err);
            });
    };

    claimReward = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        };

        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/claim-loyalty`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                this.setState({ claimLoading: false });

                if (result !== null) {
                    const myObject = JSON.parse(result);

                    if (myObject.status === 0) {
                        // موفقیت → بستن Modal تأیید + نمایش Modal موفقیت
                        this.setState({
                            isConfirmModal: false,
                            isSuccessModal: true,
                            currentStreak: 0,
                            isEligible: false,
                        });
                    } else {
                        // خطا
                        this.setState({ isConfirmModal: false });
                        if (this.props.toggleErrorMessage) {
                            this.props.toggleErrorMessage(
                                myObject.message || "خطا در دریافت جایزه"
                            );
                            this.props.toggleError();
                        }
                    }
                }
            })
            .catch((err) => {
                this.setState({ claimLoading: false, isConfirmModal: false });
                console.log("claimReward error", err);
            });
    };

    toggleConfirmModal = () => {
        if (!this.state.isEligible || this.state.claimLoading) return;
        this.setState({ isConfirmModal: !this.state.isConfirmModal });
    };

    toggleSuccessModal = () => {
        this.setState({ isSuccessModal: !this.state.isSuccessModal });
    };

    renderDayCell = (dayNumber) => {
        const { currentStreak } = this.state;
        const isActive = dayNumber <= currentStreak;
        const isRewardDay = dayNumber === this.TOTAL_DAYS;
        const isNextDay = dayNumber === currentStreak + 1;

        let cellClass = "day-cell";
        if (isActive) cellClass += " active";
        if (isRewardDay) cellClass += " reward-day";
        if (isNextDay && !isActive) cellClass += " next-day";

        return (
            <div key={dayNumber} className={cellClass}>
                {isActive && !isRewardDay && <span className="day-check">✓</span>}
                {isRewardDay && <span className="day-gift" role="img" aria-label="description">🎁</span>}
                {!isActive && !isRewardDay && <span className="day-number">{dayNumber}</span>}
            </div>
        );
    };

    render() {
        const {
            currentStreak,
            longestStreak,
            lastActiveDate,
            isEligible,
            isConfirmModal,
            isSuccessModal,
            loading,
            claimLoading,
        } = this.state;

        const progress = (currentStreak / this.TOTAL_DAYS) * 100;
        const remainingDays = this.TOTAL_DAYS - currentStreak;

        if (loading) {
            return (
                <div className="loyalty-page body-padding">
                    <div className="text-center py-5">
                        <div className="spinner-border text-warning" role="status">
                            <span className="sr-only">در حال بارگذاری...</span>
                        </div>
                        <p className="mt-3 text-muted">در حال دریافت وضعیت وفاداری...</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="loyalty-page body-padding">
                <div className="loyalty-header">
                    <h3><span role="img" aria-label="description">🎁</span> جایزه وفاداری</h3>
                    هر ۳۰ روز فعالیت متوالی = {this.REWARD_TEXT} + {this.REWARD_BONUS_TEXT}
                </div>
                <div className="streak-card">
                    <div className="streak-top">
                        <span className="streak-label">روزهای متوالی شما</span>
                    </div>

                    <div className="streak-value">
                        <span className="streak-number">{currentStreak}</span>
                        <span className="streak-total">/ {this.TOTAL_DAYS}</span>
                    </div>
                    <div className="streak-progress">
                        <div
                            className="streak-progress-fill"
                            style={{ width: `${Math.min(progress, 100)}%` }}
                        ></div>
                    </div>
                    <div className="streak-meta">
                        <div className="streak-meta-item">
                            <span className="meta-icon" role="img" aria-label="description">📅</span>
                            <span className="meta-label">آخرین فعالیت:</span>
                            <span className="meta-value">{lastActiveDate || "—"}</span>
                        </div>
                        <div className="streak-meta-item">
                            <span className="meta-icon" role="img" aria-label="description">🏆</span>
                            <span className="meta-label">طولانی‌ترین زنجیره:</span>
                            <span className="meta-value">{longestStreak} روز</span>
                        </div>
                    </div>
                </div>
                <div className="chain-section">
                    <h4 className="chain-title">زنجیره فعالیت شما</h4>
                    <div className="chain-grid">
                        {Array.from({ length: this.TOTAL_DAYS }, (_, i) =>
                            this.renderDayCell(i + 1)
                        )}
                    </div>
                    <div className="chain-legend">
                        <div className="legend-item">
                            <span className="legend-dot active"></span>
                            <span>روز فعال</span>
                        </div>
                        <div className="legend-item">
                            <span className="legend-dot"></span>
                            <span>روز پیش‌رو</span>
                        </div>
                        <div className="legend-item">
                            <span className="legend-dot reward"></span>
                            <span>روز جایزه</span>
                        </div>
                    </div>
                </div>
                <div className={`reward-card ${isEligible ? "eligible" : ""}`}>
                    <div className="reward-icon"><span role="img" aria-label="description">🎁</span></div>
                    <div className="reward-info">
                        <h4 className="reward-title">{this.REWARD_TEXT}</h4>
                        <p className="reward-subtitle"><span role="img" aria-label="description">🎡</span> + {this.REWARD_BONUS_TEXT}</p>
                        {isEligible ? (
                            <p className="reward-status success">
                                <span role="img" aria-label="description">✅</span> شما واجد دریافت جایزه هستید!
                            </p>
                        ) : (
                            <p className="reward-status">
                                <span role="img" aria-label="description">⏳</span> {remainingDays} روز دیگر تا دریافت جایزه
                            </p>
                        )}
                    </div>
                    <button
                        className={`reward-btn ${isEligible && !claimLoading ? "active" : "disabled"}`}
                        disabled={!isEligible || claimLoading}
                        onClick={this.toggleConfirmModal}
                    >
                        {claimLoading
                            ? "در حال ارسال..."
                            : isEligible
                                ? "🎉 دریافت جایزه"
                                : "🔒 قفل"}
                    </button>
                </div>
                <Modal
                    show={isConfirmModal}
                    onHide={this.toggleConfirmModal}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>تأیید دریافت جایزه وفاداری</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-3 text-justify">
                            تبریک! شما ۳۰ روز متوالی فعالیت کرده‌اید و واجد دریافت این جوایز هستید:
                        </p>

                        <div className="confirm-details">
                            <div className="confirm-row">
                                <span>روزهای متوالی:</span>
                                <strong>{currentStreak} روز</strong>
                            </div>
                            <div className="confirm-row highlight">
                                <span role="img" aria-label="description">💰 هدیه نقدی:</span>
                                <strong>{this.REWARD_TEXT}</strong>
                            </div>
                            <div className="confirm-row bonus-row">
                                <span role="img" aria-label="description">🎡 فرصت ویژه:</span>
                                <strong>{this.REWARD_BONUS_TEXT}</strong>
                            </div>
                        </div>

                        <p className="mt-3 mb-0 text-muted small text-justify">
                            با تأیید این درخواست، زنجیره فعالیت شما ریست می‌شود و
                            باید دوباره از روز ۱ شروع کنید. آیا مطمئن هستید؟
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            className="btn btn-sm btn-secondary"
                            onClick={this.toggleConfirmModal}
                            disabled={claimLoading}
                        >
                            انصراف
                        </Button>
                        <Button
                            className="btn btn-sm dina-btn-orange"
                            onClick={this.claimReward}
                            disabled={claimLoading}
                        >
                            {claimLoading ? "در حال ارسال..." : "تأیید نهایی"}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* ==== Modal موفقیت ==== */}
                <Modal
                    show={isSuccessModal}
                    onHide={this.toggleSuccessModal}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title><span role="img" aria-label="description">🎉</span> تبریک!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <div className="success-icon"><span role="img" aria-label="description">🏆</span></div>
                        <h4 className="success-title">جایزه شما ثبت شد!</h4>
                        <p className="success-message">شما برنده‌ی این جوایز شدید:</p>

                        <div className="success-prizes">
                            <div className="success-prize-item">
                                <span role="img" aria-label="description" className="prize-emoji">💰</span>
                                <span className="prize-text">{this.REWARD_TEXT}</span>
                            </div>
                            <div className="success-prize-item bonus">
                                <span role="img" aria-label="description" className="prize-emoji">🎡</span>
                                <span className="prize-text">{this.REWARD_BONUS_TEXT}</span>
                            </div>
                        </div>

                        <div className="success-note">
                            نتیجه از طریق پشتیبانی به شما اطلاع داده خواهد شد.
                            فرصت چرخاندن گردونه به‌طور خودکار به حساب شما اضافه شد.
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button
                            className="btn dina-btn-orange"
                            onClick={this.toggleSuccessModal}
                        >
                            متوجه شدم
                        </Button>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }
}

export default Loyalty;